import React, { Component } from 'react'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'

// Utils
import uga from '../assets/images/logo_uga.png'
import cerag from '../assets/images/cerag_logo.png'
import spanish from '../assets/images/spanish.png'
import french from '../assets/images/french.png'
import english from '../assets/images/english.png'

class HeadGlobal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      acceptRgpd: true,
      noAcceptRgpd: false,
    }
    this.handleChange = this.handleChange.bind(this)
  }
  handleChange = (e) => {
    const { setlang } = this.props
    setlang(e.target.value)
  }
  render() {
    const { changeLang } = this.props
    return (
      <div className='head-glob'>
        <div className='flags'>
          <img src={uga} alt='logo' className='img_logo ar1' />
          <img src={cerag} alt='logo' className='img_logo ar2' />
        </div>
        {changeLang && (
          <FormControl
            sx={{
              m: 1,
              width: {
                xs: '80%',
                sm: 270,
                md: 230,
              },
            }}
            className='area-flag'
          >
            <InputLabel htmlFor='grouped-select'>Language</InputLabel>
            <Select
              labelId='select-language'
              id='select-lang'
              defaultValue=''
              onChange={this.handleChange}
              input={<OutlinedInput label='Language' />}
            >
              <MenuItem
                key='fr'
                value='fr'
                className='itm-cntnt'
                sx={{
                  img: {
                    width: {
                      xs: '8vh',
                      sm: '5vw',
                      md: '5vw',
                    },
                  },
                }}
              >
                <img src={french} alt='lng' className='img-lng' />{' '}
              </MenuItem>
              <MenuItem
                key='es'
                value='es'
                className='itm-cntnt'
                sx={{
                  img: {
                    width: {
                      xs: '8vh',
                      sm: '5vw',
                      md: '5vw',
                    },
                  },
                }}
              >
                <img src={spanish} alt='es' className='img-lng' />
              </MenuItem>
              <MenuItem
                key='en'
                value='en'
                className='itm-cntnt'
                sx={{
                  img: {
                    width: {
                      xs: '8vh',
                      sm: '5vw',
                      md: '5vw',
                    },
                  },
                }}
              >
                <img src={english} alt='lng' className='img-lng' />
              </MenuItem>
            </Select>
          </FormControl>
        )}
      </div>
    )
  }
}
export default HeadGlobal
